<template>
    <div class="home">
        <el-container :style="{height: 100 + 'vh' }">
            <el-menu 
                background-color="#304156" 
                text-color="#fff" 
                active-text-color="#09F7F7"
                class="el-menu-vertical-demo" 
                :collapse="isCollapse" 
                unique-opened 
                @select="handleSelect"
            >
                <div>
                    <div class="biaoti" v-if="check">
                        <span class="lefttitle">华统  --  </span>
                        <span class="lefttitle">{{name}}</span>
                    </div>
                    <div class="biaoti" v-else>
                        <span style="font-size: 16px;color: #fff;font-weight:600">{{name}}</span>
                    </div>
                </div>

                <el-submenu v-for="item in menu" :index="item.id" :key="item.id">
                    <template slot="title">
                        <i :class="item.icon" style="color: #fff"></i>
                        <span slot="title">{{item.name}}</span>
                    </template>
                    <el-menu-item-group v-for="(items,index) in item.submenu1" :key="index">
                        <el-menu-item class="items.icon" :index="items.to" style="margin-top: -13px;">
                            <i :class="items.icon" style="color: #fff"></i>
                            <span>{{items.name}}</span>
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>

            </el-menu>

            <el-container>
                <el-header>
                    <div class="icons" @click="toggleCollapse">
                        <i class="el-icon-s-unfold" v-if="isCollapse"></i>
                        <i class="el-icon-s-fold" v-else></i>
                    </div>
                 
                    <div class="mbx">
                        <el-breadcrumb separator="/">
                            <el-breadcrumb-item style="cursor:pointer">首页</el-breadcrumb-item>
                            <el-breadcrumb-item v-for="(item, indexs) in breadlist" :key="'info'+indexs">
                                {{item.pathname}}
                            </el-breadcrumb-item>
                            <el-breadcrumb-item v-for="(item, index) in breadlist" :key="index" >
                                {{item.name}}
                            </el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>

                    <div class="headeright">
                        <span style="font-weight:600;font-size:12px;color:#409EFF" @click="open()"  >修改密码</span>&nbsp;
                        <span style="font-weight:600;font-size:12px;color:#409EFF" @click="logout()"  >退出</span>&nbsp;
                    </div>

                </el-header>

                <el-dialog
                    title="提示"
                    :visible.sync="dialogVisible"
                    width="400px">

                    <el-row style="margin-bottom:10px">
                        <el-col :span="6">
                            <span >新密码</span>
                        </el-col>
                        <el-col :span="18">
                            <el-input v-model="pass2" placeholder="请输入新密码（六位以上）"></el-input>
                        </el-col>
                    </el-row>

                    <el-row >
                        <el-col :span="6">
                            <span >确认密码</span>
                            
                        </el-col>
                        <el-col :span="18">
                            <el-input v-model="pass3" placeholder="确认新密码"></el-input>
                        </el-col>
                    </el-row>
                  
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible = false">取 消</el-button>
                        <el-button type="primary" @click="changePass()">确 定</el-button>
                    </span>
                </el-dialog>

                <el-main>
                    <Tags />
                    <div class="maincontent">
                        <keep-alive>
                            <!-- <router-view></router-view> -->
                            <router-view v-if="$route.meta.keepAlive"></router-view>
                        </keep-alive>
                        <router-view v-if="!$route.meta.keepAlive"></router-view>
                    </div>
                </el-main>
            </el-container>
            
        </el-container>
    </div>
</template>
<script>
    import menu from "../config/menu-config.js"
    import Tags from "../components/tags/Tags"
    import { powerList,changePwd } from '../router/api';

    export default {
        name: 'Home',
        components: { Tags },
        data() {
            return {
                menu: [],
                name: localStorage.getItem('ws_name'),
                breadlist: [],
                check: true,
                isCollapse: false,
                dialogVisible: false,
                pass2:'',
                pass3:'',
            };
        },
        watch: {
            $route(val) {
                this.getbreadlist(val);
            }
        },
       
        async mounted() {
            var tell = localStorage.getItem('ws_tell');
            var pass = localStorage.getItem('ws_pass');
            if(!tell || !pass) {
                this.$router.push('./login')
            }
            this.getbreadlist(this.$route);
        },
       
        methods: {
            open() {
                this.pass2 = ''
                this.pass3 = ''
                this.dialogVisible = true
            },
            changePass() {
                if(this.pass2 != this.pass3) {
                    this.$message({
                        message: '密码不一致，请重新输入',
                        type: 'error'
                    });
                    return
                }
                if(this.pass2.length<6) {
                    this.$message({
                        message: '密码要6位及以上', 
                        type: 'error'
                    });
                    return
                }
                changePwd({
                    name:this.name,
                    pass: this.pass2,
                }).then(res=> {
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    setTimeout(()=>{
                        this.$router.push('./login')
                    },1000)
                }).catch(err=> {
                    console.log(err);
                });
            },

            handleSelect(key, keyPath) {
                powerList({
                    id:'',
                    name:'',
                    tell: localStorage.getItem('ws_tell'),
                }).then(res => {    
                    if (res.data[0].power.includes(key)) {
                        this.$router.push(key);
                    } else {
                        this.$message.error('您没有权限');
                    }
                }).catch(err => {
                    this.$message.error('权限错误');
                    console.log(err);
                });
            },

            getbreadlist(val) {
                this.menu = menu[0]
                let obj = {
                    name: val.meta.name,
                    pathname: val.meta.pathname
                }
                let matched = []
                matched.push(obj)
                this.breadlist = matched;
            },
            
            toggleCollapse() {
                this.isCollapse = !this.isCollapse
                if (this.isCollapse == false) {
                    this.check = true;
                } else {
                    this.check = false;
                }
            },
           
            logout() {
                this.$confirm('是否确定退出?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    localStorage.clear()
                    this.$router.push('./login')
                }).catch(() => {});
            },
        },
    }
</script>
<style scoped="scoped">
    .home .el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
        font-weight: 600;
        margin-right: 10px;
    }
    .home .el-icon-arrow-down {
        font-size: 12px;
    }  
    .home .el-submenu [class^=el-icon-] {
        vertical-align: middle;
        margin-right: 5px;
        width: 24px;
        text-align: center;
        font-size: 18px;
    }  
    .home .el-menu-item {
        font-size: 12px;
    }
    .home .mbx {
        padding: 18px;
        font-size: 12px;
    }
    .home .headeright {
        position: absolute;
        right: 15px;
    }
    .home .maincontent {
         padding: 2px;
    }
    .home .biaoti {
        background-color: black;
        width: 100%;
        height: 60px;
        line-height: 60px;
        text-align: center;
    }
    .home .lefttitle {
        font-size: 14px;
        color: white;
        font-weight: 600;
    }
    .home .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 200px !important; 
        min-height: 400px;
    }
    .home .el-header {
        background-color: white;
        color: black;
        line-height: 60px;
        display: flex;
        float: left;
        padding: 0 !important;
    }
    .home .el-header i {
        font-size: 25px;
    }

    .home .el-main {
        background-color: #F1F4F5;
        padding: 20px 4px;
    }
    .home .icons {
        width: 25px;
        height: 60px;
        padding: 0 20px;
        text-align: center
    }
    .home .icons:hover {
        background: rgb(248, 248, 248);
        transition: 1s;
        cursor: pointer;
    }
    .home a {
        font-size: 9px
    }
    .home .el-submenu__title * {
        font-size: 12px;
    }
    .home  .el-container {
        display: flex;
        flex: 1;
        box-sizing: border-box;
        min-width: 0;
    }
</style>